import { render, staticRenderFns } from "./FeatureCardMultilanguage.vue?vue&type=template&id=405d379c&scoped=true&"
import script from "./FeatureCardMultilanguage.vue?vue&type=script&lang=js&"
export * from "./FeatureCardMultilanguage.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardMultilanguage.vue?vue&type=style&index=0&id=405d379c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d379c",
  null
  
)

export default component.exports